import React, { Component } from 'react';

import SocialMedia from './SocialMedia';

export default class SocialMedias extends Component {
	render () {
        return this.props.images.map((image, i)=> <SocialMedia key={i} id={i} image={image} />);
	}
}